import Scorings from '../../components/scorings';

const ScoringsPage = () => {
  return <Scorings />;
};
export default ScoringsPage;
